import { useMemo, useRef } from "react";

export default function useProgress(playbackTimeMs, bufferStartMs, currentLiveMs) {
  const prevPercentRef = useRef(0);

  const progressBarPercent = useMemo(() => {
    if (bufferStartMs == null || currentLiveMs == null || playbackTimeMs == null) {
      return prevPercentRef.current;
    }

    const denom = (currentLiveMs - bufferStartMs);
    if (!isFinite(denom) || denom <= 0) {
      return prevPercentRef.current;
    }

    let p = ((playbackTimeMs - bufferStartMs) / denom) * 100;
    if (!isFinite(p)) p = prevPercentRef.current;
    p = Math.max(0, Math.min(100, p));

    prevPercentRef.current = p;
    return p;
  }, [bufferStartMs, currentLiveMs, playbackTimeMs]);

  return { progressBarPercent };
}
